// "16:00" + "17:00" -> "4:00 – 5:00 PM" (the period is written once when both
// ends share it); "11:00" + "13:00" -> "11:00 AM – 1:00 PM"; no end -> "4:00 PM".
const parts = (t) => {
  const [h, m] = String(t).split(":").map(Number);
  if (Number.isNaN(h)) return null;
  return { clock: `${h % 12 || 12}:${String(m || 0).padStart(2, "0")}`, period: h < 12 ? "AM" : "PM" };
};

export function formatTimeRange(start, end) {
  const a = start ? parts(start) : null;
  if (!a) return "";
  const b = end ? parts(end) : null;
  if (!b) return `${a.clock} ${a.period}`;
  return a.period === b.period
    ? `${a.clock} – ${b.clock} ${b.period}`
    : `${a.clock} ${a.period} – ${b.clock} ${b.period}`;
}
